/*
 * Footer columns are collapsible on mobile only. Author CSS cannot reliably
 * force a closed <details> back open, so the markup ships `open` and this
 * element closes it below 750px instead. With JS unavailable every column
 * stays expanded, which is the pre-accordion behaviour.
 */
class FooterColumnAccordion extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.mediaQuery = window.matchMedia('(max-width: 749px)');
  }

  connectedCallback() {
    if (!this.details || !this.summary) return;

    this.onBreakpointChange = this.applyBreakpoint.bind(this);
    this.mediaQuery.addEventListener('change', this.onBreakpointChange);
    this.applyBreakpoint();
  }

  disconnectedCallback() {
    if (this.onBreakpointChange) {
      this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
    }
  }

  applyBreakpoint() {
    if (this.mediaQuery.matches) {
      this.setAttribute('data-collapsible', '');
      this.details.open = false;
      this.summary.removeAttribute('tabindex');
    } else {
      this.removeAttribute('data-collapsible');
      this.details.open = true;
      // Permanently open above mobile, so keep it out of the tab order.
      this.summary.setAttribute('tabindex', '-1');
    }
  }
}

customElements.define('footer-column-accordion', FooterColumnAccordion);
